/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from "react";
import PropTypes from "prop-types";
import "./radiogroup.scss";

class RadioButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isChecked: "",
    };
  }

  render() {
    return (
      <div
        id={this.props.id}
        className={`assignment-content ${this.props.styling}`}
      >
        <fieldset className="pe-fieldset">
          {this.props.legendTitle ? (
            <legend className="visually-hidden">
              {this.props.legendTitle}
            </legend>
          ) : (
            <legend className="ls-radio-description">
              {this.props.description}
            </legend>
          )}

          {this.props.children}
        </fieldset>
      </div>
    );
  }
}
RadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  description: PropTypes.string,
  styling: PropTypes.string,
  tooltiptext: PropTypes.string,
};

RadioButton.defaultProps = {
  isChecked: false,
  styling: "",
};

export default RadioButton;
